import lazyLoading from './lazyLoading'

export default {
  name: 'Operations',
  path: '/ops',
  meta: {
    auth: true,
    icon: 'fa-server',
    link: 'ops/index.vue'
  },
  component: lazyLoading('ops', true)
  // children : []
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/ops.js